import React from 'react'
import { Navigate } from 'react-router-dom';
import { stateT } from '../redux/reducers/types';
import { useAppSelector } from '../redux/store';

export const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const isAuthenticated = useAppSelector((state: stateT) => state.user.isAuthenticated);

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};